import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub }) => (
  <Reveal>
    <p className="mono text-xs uppercase tracking-[0.25em] text-amber-500 font-semibold">
      {overline}
    </p>
    <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-black uppercase tracking-tight text-slate-100">
      {title}
    </h2>
    {sub && (
      <p className="mt-4 max-w-2xl text-base text-slate-400 leading-relaxed">{sub}</p>
    )}
  </Reveal>
);
